module.exports = __webpack_public_path__ + "static/SnakeA-f56ad108c1308dd305800208662877f4.gif";